<template>
  <div class="confirm-save-step">
    <div class="confirm-layout">
      <div class="phone-preview">
        <div class="phone-frame">
          <img
            v-if="form.coverImage"
            class="preview-image"
            :src="form.coverImage"
            alt="转发缩略图"
          >
          <div v-else class="preview-placeholder">请上传转发缩略图</div>
        </div>
      </div>

      <div class="confirm-form-panel">
        <a-form-model
          ref="confirmForm"
          :model="form"
          :rules="rules"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-form-model-item label="营销标题" prop="marketingTitle">
            <a-input
              v-model="form.marketingTitle"
              placeholder="请输入"
              allow-clear
              @change="onMarketingTitleChange"
            />
          </a-form-model-item>
          <a-form-model-item label="转发缩略图" prop="coverImage">
            <a-upload
              list-type="picture-card"
              :show-upload-list="false"
              :action="uploadFileUrl"
              :accept="acceptTypes"
              :before-upload="beforeUploadImage"
              @change="onCoverChange"
            >
              <img v-if="form.coverImage" :src="form.coverImage" alt="cover" class="cover-image">
              <div v-else>
                <a-icon type="plus" />
                <div class="ant-upload-text">上传</div>
              </div>
            </a-upload>
            <div class="upload-tip">*支持jpg.png.webp，尺寸比例5:3，最佳尺寸500 × 400 px</div>
          </a-form-model-item>
        </a-form-model>
      </div>
    </div>

    <div class="footer-actions">
      <a-button @click="$emit('prev')">返回</a-button>
      <a-button type="primary" :loading="publishing" @click="onPublish">{{ publishText }}</a-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActivityConfirmSave',
  props: {
    marketingTitle: {
      type: String,
      default: ''
    },
    coverImage: {
      type: String,
      default: ''
    },
    publishing: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      uploadFileUrl: this.getUploadFileUrl(),
      acceptTypes: '.jpg,.jpeg,.png,.webp',
      form: {
        marketingTitle: this.marketingTitle || '',
        coverImage: this.coverImage || ''
      },
      rules: {}
    }
  },
  computed: {
    publishText () {
      return this.isEdit ? '确认并保存' : '确认并发布'
    }
  },
  watch: {
    marketingTitle (val) {
      if (val !== this.form.marketingTitle) this.form.marketingTitle = val || ''
    },
    coverImage (val) {
      if (val !== this.form.coverImage) this.form.coverImage = val || ''
    }
  },
  methods: {
    getUploadFileUrl () {
      const appConfig = this.getAppConfig()
      return appConfig.baseUrl + (appConfig.isDev ? '/' : '') + 'base/upload'
    },
    getUploadResponseUrl (file) {
      if (!file) return ''
      if (file.url) return file.url
      const response = file.response
      if (!response) return ''
      if (typeof response === 'string') return response
      if (typeof response.data === 'string') return response.data
      if (response.data && typeof response.data.url === 'string') return response.data.url
      if (typeof response.url === 'string') return response.url
      return ''
    },
    beforeUploadImage (file) {
      const fileName = file.name || ''
      const suffix = fileName.substring(fileName.lastIndexOf('.')).toLowerCase()
      const isAccept = ['.jpg', '.jpeg', '.png', '.webp'].indexOf(suffix) > -1
      if (!isAccept) {
        this.$message.error('上传文件只能是 jpg、png、webp 格式')
        return false
      }
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB')
        return false
      }
      return true
    },
    onMarketingTitleChange () {
      this.$emit('update:marketingTitle', this.form.marketingTitle)
    },
    onCoverChange (info) {
      if (info.file.status === 'done') {
        const url = this.getUploadResponseUrl(info.file)
        this.form.coverImage = url
        this.$emit('update:coverImage', url)
        this.$refs.confirmForm.validateField('coverImage')
        this.$message.success('上传成功')
      } else if (info.file.status === 'error') {
        this.$message.error('上传失败')
      }
    },
    onPublish () {
      this.$refs.confirmForm.validate(valid => {
        if (!valid) return
        this.$emit('publish', {
          marketingTitle: this.form.marketingTitle,
          coverImage: this.form.coverImage
        })
      })
    }
  }
}
</script>

<style scoped lang="less">
.confirm-save-step {
  .confirm-layout {
    display: flex;
    gap: 48px;
    justify-content: center;
    align-items: flex-start;
    min-height: 680px;
  }

  .phone-preview {
    flex-shrink: 0;
  }

  .phone-frame {
    position: relative;
    width: 320px;
    height: 640px;
    border: 1px solid #e8e8e8;
    border-radius: 24px;
    overflow: hidden;
    background: #fafafa;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  }

  .preview-image {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    object-position: top center;
  }

  .preview-placeholder {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
    font-size: 13px;
  }

  .confirm-form-panel {
    width: 420px;
    padding-top: 24px;
  }

  .cover-image {
    width: 104px;
    height: 104px;
    object-fit: cover;
  }

  .upload-tip {
    margin-top: 4px;
    color: #999;
    font-size: 12px;
    line-height: 1.5;
  }

  .footer-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 32px;
  }
}
</style>
